import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Send, Loader2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import axios from 'axios';


const Contact = () => {
  const { t } = useLanguage();
  const { toast } = useToast();
  const [sectionRef, isVisible] = useScrollAnimation(0.1);
  const [formData, setFormData] = useState({
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Získání tokenu od reCAPTCHA
      const token = await window.grecaptcha.execute('6LdljTcsAAAAANmetWDUtYJwjM2sRU_exGZXYRBp', { action: 'submit' });

      // Přidáme token do dat formuláře
      const payload = {
        user_email: formData.email,
        message: formData.message,
        token: token,
        lan: (localStorage.getItem('language') || 'en')
      };

      const response = await axios.post(
        '/api/send_email',
        payload
      );

      if (response.data.success) {

        toast({
          title: t('contact.sent'),
          description: t('contact.sendSuccess'),
        });
        setFormData({ email: "", message: "" });
      } else {
        if (response.status === 403) {
          toast({
            title: t('contact.reCaptcha'),
            description: t('contact.sendError'),
            variant: "destructive"
          });
        }
        else {
          toast({
            title: t('contact.error'),
            description: t('contact.sendError'),
            variant: "destructive"
          });
        }

      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast({
        title: t('contact.error'),
        description: t('contact.sendFailed'),
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" ref={sectionRef} className="py-20 bg-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
            {t('contact.title')}
          </h2>
          <p className="text-gray-400 text-lg">{t('contact.subtitle')}</p>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className={`bg-gray-900/50 backdrop-blur-sm border border-red-900/20 rounded-2xl p-8 transition-all duration-700 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} style={{ transitionDelay: '200ms' }}>
          {/* Hidden Honeypot – does NOT affect layout */}
          <div className="absolute opacity-0 pointer-events-none h-0 w-0 overflow-hidden" aria-hidden="true">
            <input
              type="text"
              name="honey"
              value={formData.honey}
              onChange={handleChange}
              tabIndex="-1"
              autoComplete="off"
            />
          </div>
          <div className="space-y-6">

            {/* Email */}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                {t('contact.email')}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder={t('contact.emailPlaceholder')}
                className="w-full px-4 py-3 bg-black/50 border border-red-900/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-red-500 transition-colors"
              />
            </div>

            {/* Message */}
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
                {t('contact.message')}
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows={6}
                placeholder={t('contact.messagePlaceholder')}
                className="w-full px-4 py-3 bg-black/50 border border-red-900/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-red-500 transition-colors resize-none"
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full flex items-center justify-center space-x-2 px-6 py-4 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-semibold rounded-lg transition-all hover:scale-105 disabled:hover:scale-100"
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={18} className="animate-spin" />
                  <span>{t('contact.sending')}...</span>
                </>
              ) : (
                <>
                  <span>{t('contact.send')}</span>
                  <Send size={18} />
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;